import { cn } from "../../lib/utils";
import {
  statusBadgeClass,
  statusLabel,
  purchaseStatusBadgeClass,
  purchaseStatusLabel,
} from "./utils";
import type {
  PurchaseApprovalStatus,
  PurchaseApprovalPurchaseStatus,
} from "@/services/APIs/PtsPurchaseApprovalService";

export function PurchaseApprovalStatusBadge({
  status,
}: {
  status?: PurchaseApprovalStatus | null;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium",
        statusBadgeClass(status)
      )}
    >
      {statusLabel(status)}
    </span>
  );
}

export function PurchaseApprovalPurchaseStatusBadge({
  purchaseStatus,
}: {
  purchaseStatus?: PurchaseApprovalPurchaseStatus | null;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium",
        purchaseStatusBadgeClass(purchaseStatus)
      )}
    >
      {purchaseStatusLabel(purchaseStatus)}
    </span>
  );
}
